import {Injectable, Pipe, PipeTransform} from '@angular/core';

let moment = require("moment")
@Pipe({ name: 'replace' })
export class ReplacePipe implements PipeTransform {
	transform(value: any, pattern: string | RegExp, replacement: Function | string): any {
		if (!value) return value;
		let input = value.toString();
		return input.replace(pattern, replacement)
	}

}



// WEBPACK FOOTER //
// ./src/app/ui-helper/replace.pipe.ts